export default __webpack_public_path__ + "static/media/oneEightyLogo.f3864b98.png";